import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { PutResponseBody } from '../types/api-response';
import { useFirmContext } from '../providers/FirmProvider';
import { FirmNotApplicableDescription } from '../types/firm';
import queryClient from '../query-client';

export type ReplaceFirmNotApplicableDescriptionsRequest = { description: string; sequence: number }[];

async function replaceFirmNotApplicableDescriptions(
    firmId: string,
    req: ReplaceFirmNotApplicableDescriptionsRequest
): Promise<PutResponseBody<FirmNotApplicableDescription[]>> {
    const { data } = await api.put(`/firms/${firmId}/quick-descriptions/not-applicable-descriptions`, req);
    return data;
}

export function useReplaceFirmNotApplicableDescriptions(): UseMutationResult<
    PutResponseBody<FirmNotApplicableDescription[]>,
    AxiosError,
    ReplaceFirmNotApplicableDescriptionsRequest,
    unknown
> {
    const { id: firmId } = useFirmContext();
    return useMutation((req) => replaceFirmNotApplicableDescriptions(firmId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['firm', firmId, 'not-applicable-descriptions']);
        },
    });
}
